import { isEmpty } from '@npi/buddy-utils';

import { PUBLIC_ROUTES } from 'src/Routes';

export const isPublicRoute = (route: string) => {
    const routeExist = PUBLIC_ROUTES.find((el) => {
        return route.startsWith(el.basePath);
    });

    return !isEmpty(routeExist);
};
